import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import Tab from './components/Tab';
import { useState } from 'react';
import IndexKv from './components/IndexKv';
import Statement from './components/Statement';
import FirstKv from './components/FirstKv';
import Nav from './components/nav';
import Security from './components/Security';
import International from './components/International';
import Resource from './components/Resource';
import Global from './components/Global';
import Questions from './components/Questions';
import { useLang } from '@/i18n';
export const en_page = ['us', 'ca', 'uk', 'au', 'za', 'eu'];

export default function Rule() {
    const { t } = useLang('rule');
    const [index, setIndex] = useState(0);
    const handleSetIndex = (nextIndex: number) => {
        setIndex(nextIndex);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const kvData = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1785138894603/security_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1785138878060/security_h5.jpg',
            title: t('FirstKv_title1'),
            desc: t('FirstKv_desc1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1785138903334/compliance_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1785138909830/compliance_h5.jpg',
            title: t('FirstKv_title2'),
            desc: t('FirstKv_desc2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1785139020460/privacy_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1785139034283/privacy_h5.jpg',
            title: t('FirstKv_title3'),
            desc: t('FirstKv_desc3'),
        },
    ];
    return (
        <div className={css.page}>
            {/* <A /> */}
            {index === 0 && (
                <>
                    <IndexKv />
                    <Statement onChange={handleSetIndex} />
                </>
            )}
            {index === 1 && (
                <>
                    <FirstKv data={kvData[0]} />
                    <Nav title={kvData[0].title} onHome={() => handleSetIndex(0)} />
                    <Security />
                </>
            )}
            {index === 2 && (
                <>
                    <FirstKv data={kvData[1]} />
                    <Nav title={kvData[1].title} onHome={() => handleSetIndex(0)} />
                    <International />
                    <Resource />
                </>
            )}
            {index === 3 && (
                <>
                    <FirstKv data={kvData[2]} />
                    <Nav title={kvData[2].title} onHome={() => handleSetIndex(0)} />
                    <Global />
                    <Questions />
                </>
            )}
        </div>
    );
}
